import CalendlyElement from 'components/modules/LandingPage/CalendlyElement'
import Meta from 'components/modules/SEO/Meta'
import { parseLocale } from 'lib/constants/localization'
import { onPageEnter } from 'lib/tracking/pageEnter'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useEffect } from 'react'

const CalendlyPage = () => {
    useEffect(() => {
        onPageEnter()
    }, [])

    return (
        <>
            <Meta title="Calendly" />
            <CalendlyElement />
        </>
    )
}

export const getStaticProps: GetStaticProps = async (props) => ({
    props: {
        ...(await serverSideTranslations(parseLocale(props.locale).interfaceLanguageCode, ['common'])),
    },
})

export default CalendlyPage
